(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["filter-active-pills"] && !Shopify.designMode) return;
  try {
    // Enhanced filter pills functionality
  document.addEventListener('DOMContentLoaded', function () {
    const activePills = document.querySelector('[data-active-pills]');
    if (!activePills) return;

    // Add animation when pills are removed/added
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains('filter-active-pills__pill')) {
              node.style.opacity = '0';
              node.style.transform = 'scale(0.8)';
              requestAnimationFrame(() => {
                node.style.transition = 'opacity 0.2s ease, transform 0.2s ease';
                node.style.opacity = '1';
                node.style.transform = 'scale(1)';
              });
            }
          });
        }
      });
    });

    observer.observe(activePills, {
      childList: true,
      subtree: true,
    });

    // Keyboard navigation for pills
    const pillRemoveButtons = activePills.querySelectorAll('.filter-active-pills__pill-remove');
    pillRemoveButtons.forEach((button) => {
      button.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }
      });
    });

    // Update URL without page reload (if supported)
    const pillLinks = activePills.querySelectorAll(
      '.filter-active-pills__pill-remove, .filter-active-pills__group-clear, .filter-active-pills__clear-all'
    );
    pillLinks.forEach((link) => {
      link.addEventListener('click', function (e) {
        // Add loading state
        this.setAttribute('aria-busy', 'true');

        // You could implement AJAX loading here if desired
        // For now, we let the default navigation happen
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["filter-group-list"] && !Shopify.designMode) return;
  try {
    // Filter search functionality
  document.addEventListener('DOMContentLoaded', function () {
    const searchInputs = document.querySelectorAll('[data-filter-search]');

    searchInputs.forEach((input) => {
      const filterName = input.getAttribute('data-filter-search');
      const filterList = document.querySelector(`[data-filter-list="${filterName}"]`);

      if (!filterList) return;

      input.addEventListener('input', function (e) {
        const searchTerm = e.target.value.toLowerCase();
        const items = filterList.querySelectorAll('[data-filter-item]');

        items.forEach((item) => {
          const itemText = item.getAttribute('data-filter-item');
          if (itemText.includes(searchTerm)) {
            item.removeAttribute('hidden');
          } else {
            item.setAttribute('hidden', '');
          }
        });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["icon-cart"] && !Shopify.designMode) return;
  try {
    (function () {
    function init(root) {
      var trigger = root.querySelector('.hover-cart__trigger');
      var panel = root.querySelector('.hover-cart__panel');
      if (!trigger || !panel) return;

      function open() {
        trigger.setAttribute('aria-expanded', 'true');
      }
      function close() {
        trigger.setAttribute('aria-expanded', 'false');
      }

      root.addEventListener('mouseenter', open);
      root.addEventListener('mouseleave', close);
      root.addEventListener('focusin', open);
      root.addEventListener('focusout', function (e) {
        if (!root.contains(e.relatedTarget)) close();
      });
      root.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          close();
          trigger.focus();
        }
      });
    }

    document.querySelectorAll('[data-hover-cart]').forEach(init);
  })();
  } catch(e) { console.error(e); }
})();

})();
